import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";

@Component({
    selector: "app-popover-anagraph-actions",
    templateUrl: "./popover-anagraph-actions.component.html",
    styleUrls: ["./popover-anagraph-actions.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopoverAnagraphActionsComponent implements OnInit, OnDestroy, iEvent {
  @Input() ShowDelete: boolean = false;
  @Input() ShowExport: boolean = false;
  @Input() ShowImport: boolean = false;
  @Input() ShowPDFExport: boolean = false;
  @Input() ShowExcelExport: boolean = false;
  @Input() ShowExcelCityUPExport: boolean = false;
  @Input() ViewDetail: boolean = false;
  @Input() HideDetail: boolean = false;
  @Input() Save: boolean = false;
  @Input() DeleteControlGroup: boolean = false;
  @Input() DeleteControl: boolean = false;
  @Input() InsertControl: boolean = false;
  @Input() ShowInfo: boolean = false;
  @Input() ViewAlert: string = "";
  @Input() ResetAlert: string = "";
  @Input() Duplicate: boolean = false;
  @Input() ShowArea: boolean = false;
  @Input() ShowEnvironment: boolean = false;
  @Input() ShowDevice: boolean = false;
  @Input() ShowAlexaInfo: boolean = false;
  @Input() EnableDisable: boolean = false;

  public _eventSubscriptions: Array<Subscription> = null;

  constructor(
    private _popoverController: PopoverController,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._popoverController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  itemPress(itemCode: string) {
    this._popoverController.dismiss(itemCode);
  }
}
